import { Slide } from '@mui/material';
import { PropsWithChildren, useEffect, useState } from 'react';

import FeatureTogglePanel from './FeatureTogglePanel';
import {
  FeatureToggleContext,
  getInitialState,
} from './FeatureTogglesContext';
import { FeatureToggles } from './featureToggles';

// Internally uses localstorage to maintain state across browser reloads
export const FeatureToggleProvider = ({
  overrides,
  children,
}: PropsWithChildren<{ overrides?: Partial<FeatureToggles> }>) => {
  const [toggles, setToggles] = useState(getInitialState);
  const [togglePanelOpen, setTogglePanelOpen] = useState(false);

  useEffect(() => {
    // if (!['local', 'dev'].includes(environment)) return;
    const openPanel = (event: KeyboardEvent) => {
      if (event.code === 'Backquote') return setTogglePanelOpen((last) => !last);
    };
    document.addEventListener('keydown', openPanel);
    return () => document.removeEventListener('keydown', openPanel);
  }, []);

  useEffect(() => {
    // if (!['local', 'dev'].includes(environment)) return;
    localStorage.setItem('featureToggles', JSON.stringify(toggles));
  }, [toggles]);

  return (
    <FeatureToggleContext.Provider value={{ ...toggles, setToggles, ...overrides }}>
      {children}
      <Slide in={togglePanelOpen} direction="left" unmountOnExit>
        <FeatureTogglePanel />
      </Slide>
    </FeatureToggleContext.Provider>
  );
};
